import { Component, effect, inject, input, output, signal, TemplateRef } from '@angular/core';
import { ChargingStationLocationService } from '../../services/charging-station-location.service';
import { PagedResult, PagedResultV2 } from '../../models/paging';
import {
  ChargingStationLocation,
  ChargingStationLocationSearchEvent,
} from 'src/app/features/charging-station-location/charging-station-location-model';
import { map, Observable, of } from 'rxjs';
import { TypeAheadSelector2Component } from '../type-ahead-selector2/type-ahead-selector2.component';

@Component({
  selector: 'adm-location-type-ahead',
  imports: [TypeAheadSelector2Component],
  templateUrl: './location-type-ahead.component.html',
  styleUrl: './location-type-ahead.component.scss',
})
export class LocationTypeAheadComponent {
  locationService = inject(ChargingStationLocationService);
  itemSelected = output<ChargingStationLocation | null>();
  initialId = input<string>();
  itemTemplate = input<TemplateRef<any> | undefined>(undefined);
  organizationId = input<number>();
  resetTrigger = input<{ reset: boolean }>();
  locationsFetched = output<ChargingStationLocation[] | null>();
  clearTypeAhead = output();
  placeholder = input<string>('Lokation');

  fetchLocations = (term: string): Observable<ChargingStationLocation[]> => {
    const searchEvent: ChargingStationLocationSearchEvent = {
      paging: { pageIndex: 0, pageSize: 1000, length: 0 },
      sorting: null,
      query: term.length > 0 ? term : undefined,
      hasAccessGroup: true,
      organizationId: this.organizationId() ?? undefined,
    };

    return this.locationService.getChargingStationLocationsWithAccessGroup(searchEvent).pipe(
      map((result: PagedResultV2<ChargingStationLocation>) => {
        this.locationsFetched.emit(result.items);
        return result.items;
      })
    );
  };
  fetchLocationById = (identifier: string): Observable<ChargingStationLocation | null> => {
    const searchEvent = <ChargingStationLocationSearchEvent>{
      paging: { pageIndex: 0, pageSize: 1, length: 0 },
      sorting: null,
      hasAccessGroup: false,
      organizationId: this.organizationId() ?? undefined,
      chargingStationLocationIdentifier: identifier,
    };

    return this.locationService.getChargingStationLocations(searchEvent).pipe(
      map((result: PagedResultV2<ChargingStationLocation>) => {
        const location = result.items.length > 0 ? result.items[0] : null;
        return location;
      })
    );
  };

  locationSelected = (org?: ChargingStationLocation | null) => {
    this.itemSelected.emit(org ? org : null);
  };
}
